function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeP2Dot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "147px",
    height: "32px",
    viewBox: "0 0 147 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 8 4 C 8 6.210938 6.210938 8 4 8 C 1.789062 8 0 6.210938 0 4 C 0 1.789062 1.789062 0 4 0 C 6.210938 0 8 1.789062 8 4 Z M 8 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 32 4 C 32 6.210938 30.210938 8 28 8 C 25.789062 8 24 6.210938 24 4 C 24 1.789062 25.789062 0 28 0 C 30.210938 0 32 1.789062 32 4 Z M 32 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 56 4 C 56 6.210938 54.210938 8 52 8 C 49.789062 8 48 6.210938 48 4 C 48 1.789062 49.789062 0 52 0 C 54.210938 0 56 1.789062 56 4 Z M 56 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 80 4 C 80 6.210938 78.210938 8 76 8 C 73.789062 8 72 6.210938 72 4 C 72 1.789062 73.789062 0 76 0 C 78.210938 0 80 1.789062 80 4 Z M 80 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 104 4 C 104 6.210938 102.210938 8 100 8 C 97.789062 8 96 6.210938 96 4 C 96 1.789062 97.789062 0 100 0 C 102.210938 0 104 1.789062 104 4 Z M 104 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 128 4 C 128 6.210938 126.210938 8 124 8 C 121.789062 8 120 6.210938 120 4 C 120 1.789062 121.789062 0 124 0 C 126.210938 0 128 1.789062 128 4 Z M 128 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 8 28 C 8 30.210938 6.210938 32 4 32 C 1.789062 32 0 30.210938 0 28 C 0 25.789062 1.789062 24 4 24 C 6.210938 24 8 25.789062 8 28 Z M 8 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 32 28 C 32 30.210938 30.210938 32 28 32 C 25.789062 32 24 30.210938 24 28 C 24 25.789062 25.789062 24 28 24 C 30.210938 24 32 25.789062 32 28 Z M 32 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 56 28 C 56 30.210938 54.210938 32 52 32 C 49.789062 32 48 30.210938 48 28 C 48 25.789062 49.789062 24 52 24 C 54.210938 24 56 25.789062 56 28 Z M 56 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 80 28 C 80 30.210938 78.210938 32 76 32 C 73.789062 32 72 30.210938 72 28 C 72 25.789062 73.789062 24 76 24 C 78.210938 24 80 25.789062 80 28 Z M 80 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 104 28 C 104 30.210938 102.210938 32 100 32 C 97.789062 32 96 30.210938 96 28 C 96 25.789062 97.789062 24 100 24 C 102.210938 24 104 25.789062 104 28 Z M 104 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,92.156863%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 128 28 C 128 30.210938 126.210938 32 124 32 C 121.789062 32 120 30.210938 120 28 C 120 25.789062 121.789062 24 124 24 C 126.210938 24 128 25.789062 128 28 Z M 128 28 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeP2Dot);
export default __webpack_public_path__ + "static/media/Home_P2_Dot.f2593794884b7b5f8271511b2edfc456.svg";
export { ForwardRef as ReactComponent };